import nxModule from 'nxModule';
import templateUrl from './batch-create-product-lock.template.html';
import moment from "moment";
import _ from "lodash";
import {NxRouteService} from "routes/NxRouteService";
import {ProductLockCache} from "components/service/product-lock/product-lock.cache.types";
import {CommandService} from "shared/utils/command/command.types";
import Popup from "shared/common/popup";
import ConfirmationTemplate from "shared/common/confirmationTemplate";
import {AttachedFile} from "components/service/file.service";

class BatchCreateProductLock {
  private contentFile: AttachedFile[] = [];
  readonly lockTypes: Record<string, string>[] = [
    {label: 'Blockade', type: 'BLOCKADE'}
  ];
  private type!: string;
  private remarks!: string;
  private autoReleasedOn!: Date;
  private autoRelease: boolean | undefined;

  private readonly fileExample = [
    'product_number',
    '001-0100-00001-0',
    '002-0200-00002-1'
  ].join('\n');

  private readonly sampleFile = new Blob([this.fileExample], {type: 'text/csv'});

  constructor(private readonly command: CommandService,
              private readonly confirmationTemplate: ConfirmationTemplate,
              private readonly popup: Popup,
              private readonly $route: NxRouteService,
              private readonly productLockCache: ProductLockCache) {

  }

  async execute(): Promise<void> {
    const confirmed = await this.confirmationTemplate({
      question: 'Do you want to process uploaded products?',
    });

    if (!confirmed) {
      return;
    }

    const executed = await this.command.execute<unknown, {executionErrors: [string, string][], productIds?: number[]}>('BatchCreateProductLock', {
      fileId: this.contentFile[0].id,
      type: this.type,
      autoReleasedOn: this.autoRelease ? moment(this.autoReleasedOn).format('YYYY-MM-DD') : null,
      remarks: this.remarks
    }).toPromise();

    const executionErrors = executed.output.executionErrors;
    if (executionErrors && !_.isEmpty(executionErrors)) {
      const header = '<p><span class="red"><strong>WARNING!</strong> Products listed below resulted in errors and will not be locked:</span></p>';
      const body: string[] = [];
      _.forEach(executionErrors, err => {
        body.push(...Object.entries(err).map(([errMessage, errValue]) => `<strong>${errMessage}</strong>: ${errValue}<br>`));
      });
      const errorDetails = [header, ...body].join('');
      await this.popup({
        header: 'Upload result',
        text: errorDetails,
        renderHtml: true
      });
    }
    const productIds = executed.output.productIds;
    if (productIds && !_.isEmpty(productIds)) {
      productIds.forEach((p: number) => this.productLockCache.withParam(p).evict());
    }
    this.$route.reload();
  }

  downloadSampleFile(): void {
    const sampleFileUrl = window.URL.createObjectURL(this.sampleFile);
    const a = document.createElement('a');
    a.href = sampleFileUrl;
    a.download = 'BatchCreateProductLock.csv';
    a.click();
  }
}

nxModule.component('batchCreateProductLock', {
  templateUrl,
  controller: BatchCreateProductLock
});
